import * as types from '../const/action.types';

export function reportDecreaseIsLoading(state = false, action) {
    switch (action.type) {
        case types.REPORT_DECREASE_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function reportDecrease(state = [], action) {
    switch (action.type) {
        case types.REPORT_DECREASE_VALUES_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}

export function reportDecreaseLocals(state = [], action) {
    switch (action.type) {
        case types.REPORT_DECREASE_LOCALS_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.reports.decrease.reducer.js